"use client";

import { useEffect } from "react";
import { useRouter } from "@/i18n/navigation";
import Loading from "@/components/ui/Loading";

/**
 * Redirección client-side respetando el prefijo de locale (static export no
 * soporta redirect en runtime de servidor). Usa el router de next-intl, igual
 * que el gate de rutas privadas. Muestra el spinner mientras navega.
 */
export default function RedirectTo({ href }: { href: string }) {
  const router = useRouter();

  useEffect(() => {
    router.replace(href);
  }, [router, href]);

  return <Loading />;
}
